import { API_LIMIT_DATA } from '../utils/constants';
import { Axios } from './Axios';

export function fetchClasses(orgId, offset = 1, limit = API_LIMIT_DATA) {
  let url = `/classes?populate=orgId&limit=${limit}&page=${offset}`;
  if (orgId) {
    url = `/classes?orgId=${orgId}&populate=orgId&limit=${limit}&page=${offset}`;
  }
  return Axios({
    url,
    method: 'get'
  });
}

export function createClassForOrg(classObj) {
  const url = `/classes`;
  return Axios({
    url,
    method: 'post',
    data: classObj
  });
}

export function updateClass(classId, classObj) {
  const url = `/classes/${classId}`;
  return Axios({
    url,
    method: 'patch',
    data: classObj
  });
}

export function fetchClassById(classId) {
  const url = `/classes/${classId}`;
  return Axios({
    url,
    method: 'get'
  });
}

export function deleteClassById(classId) {
  const url = `/classes/${classId}`;
  return Axios({
    url,
    method: 'delete'
  });
}
